<template lang="pug">
  NavigationDrawerMenuItemLink(
    v-if="!hasChildren"
    :name="name"
    :path="path"
    :slug="slug"
    :show-icon="showIcon"
    :clickable="clickable"
    :new-app="newApp"
    :has-children="false"
  )
    slot(name="name-info")
  .mobile-item-list(v-else)
    NavigationDrawerMenuItemLink.mobile-item-list__item(
      :name="name"
      :path="path"
      :slug="slug"
      :show-icon="showIcon"
      :clickable="clickable"
      :new-app="newApp"
      has-children
      :active-children="isActiveChildren"
      :class="{'is--farm-owners': isFarmOwnersPage}"
    )
      slot(name="name-info")
    .mobile-item-list__submenu
      NavigationDrawerMenuItemLink.mobile-item-list__submenu-item(
        v-for="subMenuItem in children"
        :key="subMenuItem.path"
        :name="subMenuItem.name"
        :path="subMenuItem.path"
        :slug="subMenuItem.slug"
        :show-icon="false"
        :new-app="subMenuItem.newApp"
        :has-children="false"
      )
</template>

<script>
import NavigationDrawerMenuItemLink from './NavigationDrawerMenuItemLink';

export default {
  name: 'NavigationDrawerMenuItem',
  components: { NavigationDrawerMenuItemLink },
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
    },
    children: {
      default: () => ([]),
      type: Array,
    },
    slug: String,
    showIcon: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    newApp: Boolean,
  },
  computed: {
    hasChildren() {
      return this.children.length;
    },
    isActiveChildren() {
      const { path } = this.$route;
      return this.children.some(val => path.startsWith(val.path));
    },
    isFarmOwnersPage() {
      const { name } = this.$route;
      return Boolean(name === 'farm-owners');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.mobile-item-list
  position: relative
  &:after
    content: ''
    position: absolute
    right: 0
    bottom: 0
    width: 100%
    height: 2px
    border-bottom: 1px solid $mercury
  &:last-child
    &:after
      display: none
  &__item
    &.is--farm-owners
      ::v-deep .mobile-item-link__link
        &:after
          display: none
        .not--active
          opacity: .3
          overflow: visible
          height: sizeInRem(10)
          width: sizeInRem(10)
        .is--active
          opacity: 0
          visibility: hidden
          width: 0
          height: 0
  &__submenu-item
    padding-left: 20px
    height: 47px
    ::v-deep .mobile-item-link__link
      padding: 12px 0
    ::v-deep .mobile-item-link__name
      padding: 0
      +font(400)
    &:after
      display: none
    &:last-child
      margin-bottom: 8px
</style>
